import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';


@Component({
  selector: 'app-benefit-commercial-focus-page',
  templateUrl: './benefit-commercial-focus-page.component.html',
  styleUrls: ['./benefit-commercial-focus-page.component.css'],

})
export class BenefitCommercialFocusPageComponent {
  ngOnInit() {
    window.scrollTo(0, 0);
  }
}
